interface Props {
  question_id?: string | number
}

export const QuestionAnswerEndpoint = {
  get: (id: any, user_id: string | number) =>
    `announcement/question-answer?content_id=${id}&business=Ellocent&user_id=${user_id}`,
  post: `question-answer`,
  getQuestions: (q: string, page: number, limit: number, status: string) =>
    `question-answer?q=${q ?? ''}${
      status && status !== 'all' ? `&status=${status}` : ''
    }&page=${page}&limit=${limit}`,
  getQuestionById: (id: number) => `question-answer?id=${id}`,
  saveDraft: (id: number) => `question-answer?id=${id}`,
  saveIgnore: (id: number) => `question-answer?id=${id}`,
  generateAnswer: ({ question_id }: Props) =>
    `generate-answers?question_id=${btoa(question_id ? JSON.stringify(question_id) : '') ?? ''}`
}
